import * as React from 'react';
import type { SVGProps } from 'react';
const SvgExternalFilter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M4.621 5.5a.75.75 0 0 0-.53 1.28l3.648 3.648c.33.33.511.773.511 1.236v5.078l3.322-.997a.25.25 0 0 0 .178-.239v-3.842c0-.464.185-.91.513-1.237l1.706-1.707.531.53.53.53-1.707 1.707a.25.25 0 0 0-.073.177v3.842a1.75 1.75 0 0 1-1.247 1.676l-3.644 1.093a1.25 1.25 0 0 1-1.609-1.197v-5.414a.24.24 0 0 0-.072-.175L3.03 7.841C1.612 6.423 2.618 4 4.62 4H9a.75.75 0 0 1 0 1.5zM14.5 9.25l.53.53a.75.75 0 1 0-1.06-1.06z"
      clipRule="evenodd"
    />
    <path d="M16.319 2h-4.357a.775.775 0 0 0-.772.772c0 .423.348.772.772.772l2.48-.001-5.215 5.231a.767.767 0 0 0 0 1.09.77.77 0 0 0 1.09 0l5.23-5.217v2.481c0 .424.348.772.772.772a.775.775 0 0 0 .772-.772V2.772A.775.775 0 0 0 16.318 2Z" />
  </svg>
);
export default SvgExternalFilter;
